import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=32e84f74&scoped=true"
import script from "./jurisdiction.vue?vue&type=script&lang=js"
export * from "./jurisdiction.vue?vue&type=script&lang=js"
import style0 from "./jurisdiction.vue?vue&type=style&index=0&id=32e84f74&scoped=true&lang=scss"
import style1 from "./jurisdiction.vue?vue&type=style&index=1&id=32e84f74&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e84f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e84f74')) {
      api.createRecord('32e84f74', component.options)
    } else {
      api.reload('32e84f74', component.options)
    }
    module.hot.accept("./jurisdiction.vue?vue&type=template&id=32e84f74&scoped=true", function () {
      api.rerender('32e84f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/jurisdiction.vue"
export default component.exports